<section class="flex flex-col">
    <div class="flex flex-col gap-2 lg:gap-3 p-4">
        <app-input
            [(value)]="query"
            (valueChange)="handleRefresh()"
            [debounce]="300"
            icon="mdi:search"
            placeholder="문서명으로 검색하세요."
        />
        <app-segment-tabs [options]="tabOptions" [(value)]="tab" />
    </div>
    <div class="flex flex-col p-4 gap-3 border-t border-gray-100">
        <!-- <ng-container *ngTemplateOutlet="searchOption"/> -->
        <div
            class="flex flex-col gap-3 lg:h-[50rem] h-[30rem] pb-[10rem] overflow-y-auto"
        >
            <app-document-box-accordian title="서비스 진행 전">
                <app-pre-document-list
                    class="overflow-x-visible"
                    onlyItems
                    [(query)]="query"
                    [(tab)]="tab"
                />
            </app-document-box-accordian>

            <app-document-box-accordian title="서비스 진행 중(공통)">
                <div class="flex flex-col gap-3">
                    @for (item of inDocuments(); track $index) {
                        <app-document-card [params]="item" />
                    }
                </div>
            </app-document-box-accordian>

            @if (isVoucher()) {
                <app-document-box-accordian title="서비스 진행 중(바우처)">
                    <div class="flex flex-col gap-3">
                        @for (item of inDocumentsVoucher(); track $index) {
                            <app-document-card [params]="item" />
                        }
                    </div>
                </app-document-box-accordian>
            }

            @if (!isProduction) {
                <app-document-box-accordian title="기타 문서">
                    <div class="flex flex-col gap-3">
                        @for (item of filteredEtcDocuments(); track $index) {
                            <app-etc-document-card [document]="item" />
                        }
                        <app-button
                            (click)="handleAddDocument()"
                            expand
                            icon="mdi:plus"
                            variant="outline"
                            color="gray"
                        >
                            추가
                        </app-button>
                    </div>
                </app-document-box-accordian>
            }
        </div>
    </div>
</section>

<ng-template #searchOption>
    <div class="hidden lg:flex w-full justify-between items-center">
        @if (editRole() || deleteRole()) {
            <app-checkbox
                (checked)="handleAllCheck($event)"
                size="sm"
                label="전체선택"
            />
        } @else {
            <div></div>
        }
        <div class="flex gap-1 items-center">
            <app-button
                (click)="handleShare()"
                [disabled]="true"
                color="gray"
                variant="outline"
                size="sm"
                >공유</app-button
            >

            @if (editRole()) {
                <app-button
                    color="gray"
                    size="sm"
                    variant="outline"
                    (click)="handleAddDocument()"
                >
                    <app-icon name="mdi:plus" size="sm" />
                </app-button>
            }
        </div>
    </div>
</ng-template>
